export const tokens = {
    gap: 8,
    padding: 16,
    height: 40,
    fontSize: 14,
    iconSize: 16,
};
